import React from "react";
import CustomPasswordInputProps from "./CustomPasswordInputProps.type";
import TextField from "@mui/material/TextField";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";

const CustomPasswordInput = ({
  id,
  label,
  onChange,
  onKeyPress,
  submitError,
  variant,
}: CustomPasswordInputProps) => {
  return (
    <>
      <TextField
        id={id ? id : "password-input"}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        variant={variant ? variant : "standard"}
        type="password"
      />
    </>
  );
};

export default CustomPasswordInput;
